import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseComponent } from '../../../models/base/base-component';
import { NgxFloatUiContentComponent, NgxFloatUiPlacements } from 'ngx-float-ui';
import { VariantFilter } from '../../../models/automation/variant-filter';

@Component({
  selector: 'app-inline-labels-picker',
  templateUrl: './inline-labels-picker.component.html',
  styleUrls: ['./inline-labels-picker.component.scss'],
  standalone: false
})
export class InlineLabelsPickerComponent extends BaseComponent implements OnChanges {
  @Input() disabled: boolean = false;
  @Input() bindTo: VariantFilter;
  @Input() mergeKey: string;
  @Input() maxSelectedLabels: number = 5;
  @Input() popperPlacement: NgxFloatUiPlacements = NgxFloatUiPlacements.TOP;

  @Output() updatedLabelIds = new EventEmitter<string[]>(true);

  @ViewChild(NgxFloatUiContentComponent) popperContent: NgxFloatUiContentComponent;

  private _labelIds = new BehaviorSubject<string[]>([]);
  public labelIds$ = this._labelIds as Observable<string[]>;

  constructor() {
    super();
  }

  override setupViews() {}

  override setupBindings() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bindTo) {
      this._labelIds.next(this.bindTo?.labelIds ?? []);
    }
  }

  // Popper
  public popperStyles = { 'background-color': '#FFFFFF' };

  public setUpdatedLabelIds(ids: string[]) {
    const copy = (ids ?? []).deepCopy();
    this.updatedLabelIds.emit(copy);
    this._labelIds.next(copy);
  }
}
